'use client';

import { FlaskConical } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';

export function DebugBanner() {
  const [isDebugMode, setIsDebugMode] = useState(false);

  useEffect(() => {
    // This code runs only on the client
    const debugUser = sessionStorage.getItem('debugUser');
    setIsDebugMode(!!debugUser);
  }, []);

  const handleExitDebugMode = () => {
    sessionStorage.removeItem('debugUser');
    window.location.reload();
  };

  if (!isDebugMode) {
    return null;
  }

  return (
    <div className="fixed right-4 bottom-4 z-50 rounded-lg border border-yellow-500/30 bg-gray-900/80 p-3 text-white shadow-lg backdrop-blur-md">
      <div className="flex items-center gap-3">
        <FlaskConical className="h-5 w-5 text-yellow-400" />
        <div>
          <p className="font-bold text-sm text-yellow-300">Debug Mode Active</p>
          <p className="text-xs text-yellow-400/80">Test mode active.</p>
        </div>
        <Button
          className="ml-4 border-yellow-500/50 text-yellow-300 hover:bg-yellow-500/10"
          onClick={handleExitDebugMode}
          size="sm"
          variant="secondary"
        >
          Exit
        </Button>
      </div>
    </div>
  );
}
